import { useMutation } from 'data-fetching-client';
import { ASSIGN_THREAD_MUTATION } from '../mutations/assignThread';
export const useAssignThread = options => useMutation(ASSIGN_THREAD_MUTATION, options);